export default __webpack_public_path__ + "static/media/pic3.83f0d232.jfif";